import { alpha } from '@mui/material/styles'

/** @type {Styles} */
export const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  breadcrumbLink: {
    textTransform: 'capitalize',
    textDecoration: 'none',
    color: 'gray.64',
  },
  breadcrumbs: {
    color: 'gray.64',
    fontWeight: 600,
    lineHeight: 1.4,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '& .MuiBreadcrumbs-ol': {
      alignItems: 'center',
      '& .MuiBreadcrumbs-li': {
        display: 'contents',
        fontSize: 14,
        ':hover': {
          color: 'gray.100',
          display: 'contents',
        },
      },
      '.MuiBreadcrumbs-li:last-child': {
        color: 'gray.80',
        display: 'contents',
      },
      '& .MuiBreadcrumbs-separator': {
        color: 'gray.48',
        display: 'contents',
        '& .MuiSvgIcon-root': {
          color: 'gray.48',
          fontSize: 12,
        },
      },
    },
  },
  breadcrumbsBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flex: 1,
  },
  downloadwidgetBox: { display: 'flex', marginLeft: 'auto' },
  downloadIcon: {
    border: '1px solid gray',
    borderRadius: 10,
    width: 35,
    height: 35,
  },
  colonSeparator: {
    mx: 0.5,
    fontSize: '1rem',
    marginTop: -0.25,
    color: 'gray.64',
  },
  angleRightSeparator: { mx: 0.5, fontSize: '1rem', marginTop: 0.25 },
  contextContainer: { marginRight: 1 },
  contextButton: {
    '&.MuiButton-root': {
      lineHeight: 1.75,
    },
  },

  countBox: {
    bgcolor: 'primary.main',
    color: 'gray.0',
    fontWeight: 'bold',
    fontSize: '0.75rem',
    minWidth: 24,
    height: 24,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    color: 'primary.lightest',
    fontSize: '1.5rem',
  },
  entityStyles: {
    marginRight: 0.5,
    color: 'gray.56',
    typography: 'header4',
    ':hover': {
      color: 'gray.64',
    },
  },
  aiTrigger: {
    marginLeft: 'auto',
    color: 'green.dark',
    '&:hover': {
      bgcolor: (theme) => alpha(theme.palette.green.dark, 0.08),
    },
  },
}

export const stylesWithProps = (isDisabled) => ({
  pointerEvents: isDisabled && 'none',
  color: isDisabled && 'gray.56',
  textDecoration: isDisabled && 'none',
  cursor: isDisabled && 'not-allowed',
})
